import { makeAutoObservable } from "mobx";

export type UpdateStatus = "current" | "update-available";

export class ShellStatusStore {
  online = typeof navigator === "undefined" ? true : navigator.onLine;
  updateStatus: UpdateStatus = "current";
  private started = false;
  private readonly onOnline = (): void => { this.markOnline(); };
  private readonly onOffline = (): void => { this.markOffline(); };
  private readonly onUpdateAvailable = (): void => { this.markUpdateAvailable(); };

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  markOnline(): void { this.online = true; }
  markOffline(): void { this.online = false; }
  markUpdateAvailable(): void { this.updateStatus = "update-available"; }
  get updateAvailable(): boolean { return this.updateStatus === "update-available"; }
  requestUpdate(): void {
    if (typeof window !== "undefined") window.location.reload();
  }

  start(): () => void {
    if (this.started || typeof window === "undefined") return () => undefined;
    this.started = true;
    window.addEventListener("online", this.onOnline);
    window.addEventListener("offline", this.onOffline);
    window.addEventListener("thw:update-available", this.onUpdateAvailable);
    return () => {
      this.started = false;
      window.removeEventListener("online", this.onOnline);
      window.removeEventListener("offline", this.onOffline);
      window.removeEventListener("thw:update-available", this.onUpdateAvailable);
    };
  }
}
